import React from "react";
import Map from "./components/Map/Map";

function App() {
  return (
    <div className="App">
      <h1>Vehicle Movement Tracker</h1>
      <Map />
    </div>
  );
}

export default App;
